'use client';

// Kept as a thin adapter around `ArticlePageWrapper` so the existing blog route
// keeps working. New pages should use `ArticlePageWrapper` directly.
import { ArticlePageWrapper } from './ArticlePageWrapper';
import type { AuthorDocument, BlogDocument } from '../../../prismicio-types';

interface BlogPageWrapperProps {
  page: BlogDocument<string>;
  author: Partial<AuthorDocument>;
}

export function BlogPageWrapper({ page, author }: BlogPageWrapperProps) {
  return (
    <ArticlePageWrapper
      article={page}
      author={author}
      imageLayout={page.data.image_layout}
    />
  );
}
